<template>
    <div v-if="servicesLoad && !addServiceDisabled" class="central-service" ref="services">
        <v-expansion-panels
            v-model="selectedCalc"
            class="main_panel ml-auto mr-3 mt-2"
        >
            <v-expansion-panel
                v-for="(item, index) in filteredService"
                :key="'calc-key-' + index"
                class="mb-3"
                :id="'calc_' + index"
            >
                <v-expansion-panel-header
                    disable-icon-rotate
                    class="header2 headline"
                    :class="isCommodity(item) ? 'commodity-border' : ''"
                    :data-test-id="'calc_' + index"
                >
                    <v-btn
                        class="my-1 mr-4  v-expansion-panel-header__icon"
                        small
                        icon
                        fab
                    >
                        <v-img
                            :src="item.image ? '/' + item.image : ''"
                            height="64px"
                            width="64px"
                            class="mr-2 pr-1"
                        ></v-img>
                    </v-btn>
                    <span :data-test-id="'calcText_' + index">{{ item.title }}</span>
                    <span class="infoBonus">
                        <v-icon
                            color="#B0BEC5"
                            style="width:28px;height:28px"
                            @click.native.stop="showServiceInfo(item)"
                            >mdi-information-outline</v-icon
                        >
                        <span v-if="item.is_moneybox" class="kopilka">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <svg
                                        v-on="on"
                                        style="width:28px;height:28px"
                                        viewBox="0 0 28 28"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M22 14H20C20 11.6 18.2 9.6 15.5 8.6C15 9.4 14.1 10 13 10C11.7 10 10.7 9.2 10.2 8.2C10 8.2 9.8 8.3 9.5 8.3L7 7V9.3C5.5 10.2 4.4 11.5 4.1 13H2V17H5.1C5.6 17.6 6.2 18.2 7 18.7V22H9V19.6C9.9 19.9 10.9 20 12 20S14.1 19.8 15 19.6V22H17V18.7C18.1 18 19 17.1 19.5 16H22V14M12 18C8.7 18 6 16.2 6 14C6 12.5 7.4 11.1 9.4 10.4C10.3 11.4 11.6 12 13 12C14.1 12 15.1 11.7 16 11C17.3 11.8 18 12.9 18 14C18 16.2 15.3 18 12 18M13 3C13.6 3 14 3.4 14 4S13.6 5 13 5 12 4.6 12 4 12.4 3 13 3M13 1C11.3 1 10 2.3 10 4S11.3 7 13 7 16 5.7 16 4 14.7 1 13 1M10 13C10 13.6 9.6 14 9 14S8 13.6 8 13 8.4 12 9 12 10 12.4 10 13"
                                        />
                                    </svg>
                                </template>
                                <span>Услуга участвует в копилке</span>
                            </v-tooltip>
                        </span>
                        <span v-if="item.bonus > 0" class="bonuss">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        color="#da652c"
                                        style="width:28px;height:28px"
                                        >mdi-fire</v-icon
                                    >
                                </template>
                                <span
                                    >Услуга участвует в программе бонусов</span
                                >
                            </v-tooltip>
                        </span>
                        <span v-if="isCommodity(item)" class="bonuss">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        color="#da652c"
                                        style="width:28px;height:28px"
                                    >
                                      mdi-package-variant-closed
                                    </v-icon>
                                </template>
                                <span>Товар</span>
                            </v-tooltip>
                        </span>
                    </span>

                    <b></b>
                    <span v-if="item.price == '0.00'"></span>
                    <span v-else-if="item.calc_type == 'SeasonalStorageCalc'">
                      {{ priceIntervalSeasonalStorageCalc }}
                    </span>
                    <span class="text-right" v-else>
                      {{ priceFormated(item) }} ₽
                    </span>
                    <template v-slot:actions>
                        <v-btn
                            v-if="
                                !item.calc_type ||
                                    item.calc_type == 'SimpleCalc'
                            "
                            :data-test-id="'addOrder_' + index"
                            color="#C8FA92"
                            class="ml-3"
                            max-width="90"
                            fab
                            small
                            @click.native.stop="addServiceToCart(item)"
                        >
                            <v-icon>mdi-plus-thick</v-icon>
                        </v-btn>
                        <v-btn class="ml-3" fab small v-else                         :data-test-id="'addOrder_' + index"
                        >
                            <v-img
                                src="../../../assets/images/order/calc.png"
                                height="44px"
                                width="44px"
                                class="mr-2 ml-2 pr-1"
                            ></v-img>
                        </v-btn>
                        <span class="d-none">
                            <v-btn
                                class="ma-0 mr-2 v-expansion-panel-header__icon--disable-rotate"
                                small
                                icon
                                color="#9B9B9B"
                            >
                                <v-icon>mdi-pin</v-icon>
                            </v-btn>
                            <v-btn
                                class="ma-0 mr-2 v-expansion-panel-header__icon--disable-rotate"
                                small
                                icon
                                color="black"
                                @click.native.stop="infoClick()"
                            >
                                <v-icon>mdi-information</v-icon>
                            </v-btn>
                            <v-btn
                                class="ma-0 mr-2 v-expansion-panel-header__icon--disable-rotate"
                                small
                                icon
                                color="black"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </span>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <tireRepair
                        v-if="
                            item.calc_type == 'TyreRepairCalc' &&
                                !item.calc_subtype
                        "
                        :itemID="index"
                    />
                    <diskRepair
                        v-if="
                            item.calc_type == 'DiskRepairCalc' &&
                                !item.calc_subtype
                        "
                        :itemID="index"
                    />
                    <diskPaint
                        v-if="item.calc_type == 'DiskPaintCalc'"
                        :itemID="index"
                    />
                    <diskPaint1
                        v-if="item.calc_type == 'DiskPaintCalc1'"
                        :itemID="index"
                    />
                    <tireChange
                        v-if="item.calc_type == 'SimpleCalc'"
                        :type="item.title"
                        :itemID="index"
                    />
                    <seasonalStorage
                        v-if="item.calc_type == 'SeasonalStorageCalc'"
                        :itemID="item.id"
                        @scrollTo="scrollTo"
                    />
                    <span v-if="item.calc_type == 'ManualCalc'">
                        <v-container>
                            <v-row>
                                {{ item.description }}
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="8">
                                    <span class="pt-3 pr-3">
                                        <v-btn
                                            @click="
                                                customPrice = customPrice + 10
                                            "
                                            rounded
                                            depressed
                                            ><v-icon small>+10 ₽</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                customPrice = customPrice + 100
                                            "
                                            rounded
                                            depressed
                                            ><v-icon small
                                                >+100 ₽</v-icon
                                            ></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                customPrice = customPrice + 1000
                                            "
                                            rounded
                                            depressed
                                            ><v-icon small
                                                >+1000 ₽</v-icon
                                            ></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                customPrice < item.minimum_price
                                                    ? ''
                                                    : customPrice--
                                            "
                                            x-small
                                            fab
                                            depressed
                                            class="ml-2"
                                            ><v-icon>mdi-minus</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="customPrice++"
                                            x-small
                                            fab
                                            depressed
                                            ><v-icon>mdi-plus</v-icon></v-btn
                                        >
                                    </span>
                                    <v-text-field
                                        v-model="customPrice"
                                        prefix="₽"
                                        label="Стоимость"
                                        @blur="checkPrice(index)"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn
                                        large
                                        color="#C8FA92"
                                        class="mt-1"
                                        block
                                        @click="
                                            addServiceToCartCustomPrice(item)
                                        "
                                    >
                                        Добавить
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </span>
                    <span v-if="!item.calc_type">
                        <v-container>
                            <v-row>
                                {{ item.description }}
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="8">
                                    <span class="pt-3 pr-3">
                                        <v-btn
                                            @click="item.quantity = 1"
                                            x-small
                                            fab
                                            depressed
                                            ><v-icon>1</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="item.quantity = 4"
                                            x-small
                                            fab
                                            depressed
                                            ><v-icon>4</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                item.quantity =
                                                    item.quantity + 10
                                            "
                                            rounded
                                            depressed
                                            ><v-icon small>+10</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                item.quantity =
                                                    item.quantity + 100
                                            "
                                            rounded
                                            depressed
                                            ><v-icon small>+100</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="
                                                item.quantity === 0
                                                    ? ''
                                                    : item.quantity--
                                            "
                                            x-small
                                            fab
                                            depressed
                                            class="ml-2"
                                            ><v-icon>mdi-minus</v-icon></v-btn
                                        >
                                        <v-btn
                                            @click="item.quantity++"
                                            x-small
                                            fab
                                            depressed
                                            ><v-icon>mdi-plus</v-icon></v-btn
                                        >
                                    </span>
                                    <v-text-field
                                        v-model="item.quantity"
                                        label="Количество"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn
                                        large
                                        color="#C8FA92"
                                        class="mt-1"
                                        block
                                        @click="addServiceToCart(item)"
                                    >
                                        Добавить
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </span>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
    <div v-else>
        <v-expansion-panels
            v-if="addServiceDisabled"
            class="main_panel ml-auto mr-auto"
        >
            <div class="alert alert-warning" role="alert">
                Чтобы изменить заказ нужно вернуть его В РАБОТУ
            </div>
        </v-expansion-panels>
    </div>
</template>
<script>
import seasonalStorage from "../../calcs/SeasonalStorage.vue";
import tireRepair from "../../calcs/TireRepair.vue";
import diskPaint from "../../calcs/DiskPaint.vue";
import diskPaint1 from "../../calcs/DiskPaint1.vue";
import diskRepair from "../../calcs/DiskRepair.vue";
import tireChange from "../../calcs/TireChange.vue";
import { mapGetters } from "vuex";

export default {
    filters: {
        onlyNumbers(value) {
            return value;
        }
    },
    components: {
        diskRepair,
        seasonalStorage,
        tireRepair,
        diskPaint,
        diskPaint1,
        tireChange
    },
    data() {
        return {
            customPrice: 0,
            numberOf: [],
            info: [
                {
                    title: "Горячая вулканизация",
                    text:
                        "Рекомендуем при порезах от 3-х мм. Увеличивает надежность заплатки, резина становится как новая.",
                    img: require("../../../assets/info1.png"),
                    price: this.tab
                },
                {
                    title: "Восстановление защитной кромки",
                    text:
                        "Когда делаем горячую вулканизацию, есть возможность восстановить затную кромку — шина станет как новая.",
                    img: require("../../../assets/info2.png"),
                    price: this.tab
                }
            ],
            showInfo: false,
            panel: null,
            addServiceDisabled: false,
            duration: 300,
            offset: 10,
            easing: "easeInOutCubic",
            scrollContainer: "div.central-service"
        };
    },
    computed: {
        ...mapGetters([
            "servicesLoad",
            "services",
            "cart",
            "runflat",
            "frameVehicle",
            "order",
            "client",
            "chosenMark",
            "chosenModel",
            "chosenPromocode",
        ]),
        priceIntervalSeasonalStorageCalc () {
          const seasoStore = Object.values(this.services).filter(item => item.calc_type === 'SeasonalStorageCalc')
          let minP = null
          let maxP = null
          seasoStore.forEach((sc) => {
            if (!minP) minP = parseInt(sc.price)
            if (!maxP) maxP = parseInt(sc.price)
            if (minP > parseInt(sc.price)) minP = parseInt(sc.price)
            if (maxP < parseInt(sc.price)) maxP = parseInt(sc.price)
          })
          return 'от ' + this.numberWithSpaces(minP) + '₽ до ' + this.numberWithSpaces(maxP) + '₽'
        },
        filteredService() {
          let first = true
            return Object.values(this.services).filter(
                (item) => {
                  if (item.calc_type === 'SeasonalStorageCalc' && first) {
                    first = false
                    return true
                  } else if (item.calc_type === 'SeasonalStorageCalc' && !first){
                    return false
                  } else {
                    return !item.calc_subtype
                  }
                }
            );
        },
        options() {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing,
                container: this.scrollContainer
            };
        },
        chosenServices: {
            get() {
                return this.$store.getters.chosenServices;
            },
            set(value) {
                this.$store.commit("updateChosenServices", value);
            }
        },
        selectedCalc: {
            get() {
                return this.$store.getters.selectedCalc;
            },
            set(value) {
                this.$store.commit("setSelectedCalc", value);
            }
        }
    },
    async mounted() {
        this.$store.commit("setLicensePlate", "x111xx123");
        this.$store.commit("clearServices");
        this.$store
            .dispatch("change/changePrice")
            .then(resp => {
                console.log("resp", resp);
            })
            .catch(e => {
                console.log("error:", e);
            });
        this.$store
            .dispatch("paint/diskPaintPrice")
            .then(resp => {
                console.log("diskPaintPrice", resp);
            })
            .catch(e => {
                console.log("error:", e);
            });
        this.$store
            .dispatch("diskrepair/diskRepairPrice")
            .then(resp => {
                console.log("diskRepairPrice", resp);
            })
            .catch(e => {
                console.log("error:", e);
            });
    },
    watch: {
        customPrice(newval) {
            this.filteredService[this.selectedCalc].price = parseFloat(newval);
        },
        selectedCalc(newval) {
            this.filteredService[newval]
                ? (this.filteredService[newval].quantity = 1)
                : "";
            if (newval || newval === 0) {
                console.log("as");
                const calcnumber = newval;
                setTimeout(
                    () =>
                        this.$vuetify.goTo("#calc_" + calcnumber, this.options),
                    600
                );
                this.customPrice = parseFloat(
                    this.filteredService[newval].price
                );
            }
        },
        order() {
            this.order.status == "ready" ||
            this.order.status == "paymentpending"
                ? (this.addServiceDisabled = true)
                : (this.addServiceDisabled = false);
        }
    },
    methods: {
        isCommodity (item) {
          return item&&item.pivot&&item.pivot.commodity_id
        },
        scrollTo(y) {
            const offset = -150;
            const wrapper = this.$refs.services;
            const wrapperHeight = wrapper.scrollTop
            this.$refs.services.scroll(0, wrapperHeight + y + offset);
        },
        showServiceInfo(service) {
            console.log("service info", service);
            let servInfo = {
                show: false,
                image: null,
                title: service.title,
                description: service.description,
                content: service.content,
                warranty: service.warranty,
                warranty_period: service.warranty_period,
                duration: service.duration,
                master_sallary: service.master_sallary,
                presentation: service.presentation,
                traningVideo: "", //null, //todo: add videolink
                techCard: "" //null, //todo: add techCardLink
            };
            this.$store.commit("showServiceInfoModal", servInfo);
        },
        checkPrice(i) {
            this.customPrice = parseFloat(
                this.customPrice.replace(/[^0-9]/g, "")
            );
            if (
                parseFloat(this.customPrice) <
                parseFloat(this.filteredService[i].minimum_price)
            )
                this.customPrice = parseFloat(
                    this.filteredService[i].minimum_price
                );
            else this.customPrice = parseFloat(this.customPrice);
        },
        numberWithSpaces(x) {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "";
        },
        priceFormated(value) {
            let price =
                typeof value.price == "string"
                    ? value.price.split(".")[0]
                    : value.price;
            return this.numberWithSpaces(price);
        },
        addServiceToCart(service) {
            console.log("dsd", service);
            if (service.pivot && service.pivot.commodity_id) {
              service.type = 'commodity'
            } else {
              service.type = 'service'
            }
            this.$store
                .dispatch("addServiceToCart", {
                    service: service,
                    client: this.$store.getters.client,
                    quantity: service.quantity
                })
                .then(() => {
                    this.$store
                        .dispatch("fetchPricesWithCartItems", {
                            cart: this.chosenServices,
                            promocode: this.chosenPromocode,
                            client: this.client
                        })
                        .then(() => {
                          if (this.order.id) {
                            this.updateOrder();
                          }
                        });
                });
        },
        addServiceToCartCustomPrice(service) {
            console.log("dsd", service);
            this.$store.dispatch("addServiceToCart", {
                service: service,
                client: this.$store.getters.client,
                quantity: 1
            });
            if (this.order.id) {
                this.updateOrder();
            }
        },
        loadServices(reasonId) {
            this.$store.dispatch("fetchServices", reasonId);
        },
        updateOrder() {
            this.$store.dispatch("updateOrder", {
                cart: this.cart,
                client: this.client,
                clientPhone: this.client.customer.phone ?? "",
                promocode: this.chosenPromocode,
                shift: this.shiftData,
                status: status,
                order_id: this.order.id,
                mark: this.chosenMark ?? "",
                model: this.chosenModel ?? "",
                runflat: this.runflat,
                frameVehicle: this.frameVehicle,
                employee: this.choosenEmployee ?? ""
            });
        }
    }
};
</script>
<style lang="scss">
.commodity-border {
  border:2px solid #f67423;
}
.central-service {
    max-height: 84vh;
    overflow-y: auto;
}
.central-service::-webkit-scrollbar {
    width: 5px;
}
.central-service::-webkit-scrollbar-thumb {
    background: #919191;
}
.central-service::-webkit-scrollbar-track {
    background: #d3d3d3;
}
.infoBonus {
    position: inherit;
    top: -13px;
    left: 7px;
}
.kopilka {
    color: goldenrod;
}
.bonuss {
    position: inherit;
    left: -7px;
}
.fullprice {
    position: absolute;
    text-decoration: line-through;
    top: 4px;
    left: 4px;
}
.discount {
    position: absolute;
    font-size: 13px;
    height: 36px;
    width: 36px;
    text-align: center;
    line-height: 36px;
    vertical-align: center;
    border-radius: 50%;
    background-color: rgba(122, 163, 255, 0.42);
    color: brown;
    top: 16px;
    left: 32px;
}
.discountprice {
    position: absolute;
    font-size: 20px;
    right: 10px;
    bottom: 3px;
}
.timeToSet {
    position: absolute;
    font-size: 13px;
    right: 10px;
    top: 3px;
}
.price {
    position: relative;
    background-color: #c2dcfa;
    height: 56px;
    top: 0;
}
.result-text {
    height: 100%;
    border-radius: 16px;
    border-top-right-radius: 0;
    background-color: #c2dcfa;
}
.theme--light.v-card.main_bg_color {
    background-color: #fffeee;
}
.v-tab.v-tab--active {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    background-color: #fffeee;
}
.v-tab {
    margin-right: 6px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    background-color: #e9e9e9;
}
.tabs_icons {
    width: 24px;
    height: 31px;
}
.v-item-group.main_panel {
    max-width: 911px;
}
.header {
    height: 67px;
    background: #fffbcd;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.5);
    display: flex;
}

.label {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
}

.submit {
    width: 199px;
    min-height: 56px;
    background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%) !important;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
    border-radius: 11px;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 18px;
    text-align: center;
    color: #4a4a4a;
}

.tab-content {
    padding: 0 32px 16px;
}

.text-card {
    $radius: 30px;
    padding: 10px 15px;
    background: #c2dcfa;
    border-radius: $radius 0 $radius $radius;
}

.left {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: flex-start;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
 {
    opacity: 0;
}
.v-btn-toggle > .v-btn.v-btn--active {
    background-color: #fffbcd !important;
}
</style>
